import React from 'react';
import InputMask from 'react-input-mask';
import styles from './inputField/InputField.module.scss';

export default React.memo(props => {
  return <InputMask className={styles.input} maskChar="" {...props} />;
});
